import axiosInstance from './axios';

export const get = (url, config = {}) => {
  return axiosInstance.get(url, config).then((data) => data)
    .catch(({ response }) => {
      const { status } = response;
      if (status === 401) {
        localStorage.removeItem('token');
        window.location.replace('/');
      } else {
        throw response;
      }
    });
};
export const authGet = (url, { params, headers } = {}) => {
  const { token } = JSON.parse(localStorage.getItem('token')) || null;
  return get(
    url,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        ...headers
      },
      params
    }
  );
};
export const set = (method, url, body, headers = {}) => {
  const isFormData = typeof FormData !== 'undefined' && body instanceof FormData;
  const normalizedHeaders = isFormData
    ? {
      'Content-Type': 'multipart/form-data',
      ...headers
    }
    : {
      'Content-Type': 'application/json',
      ...headers
    };

  return axiosInstance({
    url,
    data: body,
    method,
    headers: normalizedHeaders
  }).then(({ data }) => data)
    .catch((error) => {
      if (error?.response?.data) {
        throw error.response.data;
      }

      const rawResponse = error?.request?.response;
      if (rawResponse) {
        throw JSON.parse(rawResponse);
      }

      throw error;
    });
};
export const authSet = (method, url, body, headers = {}) => {
  const { token } = JSON.parse(localStorage.getItem('token')) || null;
  return set(
    method,
    url,
    body,
    {
      Authorization: `Bearer ${token}`,
      ...headers
    }
  );
};

export const authSetFile = (url, body, headers = {}) => {
  const { token } = JSON.parse(localStorage.getItem('token')) || null;
  return set(
    'POST',
    url,
    body,
    {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
      ...headers
    }
  );
};
